(function () {
  const $banners = document.querySelectorAll('section.banner_block_new .frames.animated');

  if ($banners.length) {
    $banners
      .forEach($banner => {
        const delay = $banner.dataset.delay;
        let currentIndex = 0;

        setInterval(() => {
          const $frames = $banner.querySelectorAll('.frame');
          const frameCount = $frames.length;

          $frames[currentIndex].classList.remove('active');
          currentIndex = (currentIndex + 1) % frameCount;
          $frames[currentIndex].classList.add('active');
        }, delay);
      });
  }
})();

